"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.valueValidator = valueValidator;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * If provided, defaultValue and/or  value must be a string that is the ID of an option
 * within the array of options. Both values can not be provided.
 *
 * @param {SelectProps} props
 * @param {('defaultValue' | 'value')} propName
 * @param {'Select'} componentName
 * @returns {(Error | null)}
 */
function valueValidator(props, propName, componentName) {
  if (process.env.NODE_ENV !== 'production') {
    var defaultValue = props.defaultValue,
        options = props.options,
        value = props.value,
        current = props[propName];

    if (!!defaultValue && !!value) {
      return new Error("Both `defaultValue` and `value` are supplied to `".concat(componentName, "`. `defaultValue` will not be used. Validation failed."));
    }

    if (!!current && !(0, _utils.getOptionFromOptions)(options, current)) {
      return new Error("Invalid prop `".concat(propName, "` supplied to `").concat(componentName, "`. The value of `").concat(propName, "` must be the ID of an option. Validation failed."));
    }

    _propTypes.default.checkPropTypes(_defineProperty({}, propName, _propTypes.default.string), props, propName, componentName);
  }

  return null;
} // eslint-disable-next-line import/prefer-default-export